import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Modal } from "react-responsive-modal";
import styled from "styled-components";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  setVisibleSelectArea: any;
};

const passwordTemp = "0210";

const PasswordModal = ({
  isVisible,
  setVisible,
  setVisibleSelectArea,
}: Props) => {
  const [password, setPassword] = useState<string>("");
  const [passwordArray, setPasswordArray] = useState<number[][]>([
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [0],
  ]);

  const onClose = () => {
    setVisible(false);
  };

  const onClickPassword = (value: number) => {
    setPassword(password + value);
  };

  const backspacePassword = () => {
    setPassword(password.slice(0, -1));
  };
  const resetPassword = () => {
    setPassword("");
  };

  useEffect(() => {
    setPassword("");
  }, [isVisible]);

  useEffect(() => {
    if (password.length === 4) {
      if (password === passwordTemp) {
        setVisible(false);
        setVisibleSelectArea(true);
      } else toast.error("실패");
      setPassword("");
    }
  });

  const RenderPassword = () => {
    const passwordCheck = () => {
      return password;
    };
    const passwordLengthCheck = () => {
      return password.length;
    };
    return (
      <>
        {Array.from(passwordCheck()).map((item: any, index: number) => {
          return <div key={index} className="password" />;
        })}
        {Array(4 - passwordLengthCheck())
          .fill(null)
          .map((item: any, index: number) => {
            return <div key={index} className="password inactive" />;
          })}
      </>
    );
  };

  const RenderNumberPad = () => {
    return (
      <>
        {passwordArray.map((itemArray: number[], arrayIndex: number) => {
          return arrayIndex === 3 ? (
            <div key={arrayIndex} className="numberArraySource">
              <button className="numberSource clear" onClick={resetPassword}>
                <h3>전체지우기</h3>
              </button>
              <button
                className="numberSource"
                onClick={() => onClickPassword(0)}
              >
                <h2>0</h2>
              </button>
              <button className="numberSource" onClick={backspacePassword}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_backspace_green.svg`}
                  alt="backspace"
                />
              </button>
            </div>
          ) : (
            <div key={arrayIndex} className="numberArraySource">
              {itemArray.map((item: number, index: number) => {
                return (
                  <button
                    key={index}
                    className="numberSource"
                    onClick={() => onClickPassword(item)}
                  >
                    <h2>{item}</h2>
                  </button>
                );
              })}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      closeOnOverlayClick={false}
      classNames={{
        overlay: "passwordModalOverlay",
        modal: "passwordModal",
        root: "customModalRoot",
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
    >
      <Style>
        <div className="modalWrapper">
          <div className="passwordWrap">
            <h2>비밀번호를 입력해주세요</h2>
            <div className="securePasswordWrap">
              <RenderPassword />
            </div>
          </div>
          <div className="numberPadWrap">
            <RenderNumberPad />
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default PasswordModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }
  /* modalWrapper */
  .modalWrapper {
    position: relative;
    padding: 30px 0;
    height: 100%;
    background: #343434;
    overflow: hidden;
  }

  .passwordWrap {
    height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #343434;
    padding: 10px 0;
    gap: 10px;
    position: relative;
    h2 {
      padding: 70px 0 50px 0;
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 10px;
      line-height: 40px;
      white-space: pre-line;
      color: #ffffff;
    }

    .securePasswordWrap {
      display: flex;
      align-items: center;
      gap: 32px;
      padding: 10px 0 30px 0;
    }
    .password {
      width: 16px;
      height: 16px;
      border-radius: 100px;
      background: #4dd2ae;
    }
    .password.inactive {
      background: #d9d9d9;
    }
  }
  .numberPadWrap {
    padding: 40px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .numberArraySource {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .numberSource {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      padding: 20px 0;
      background: #343434;
      border: none;
      cursor: pointer;
      h2 {
        font-size: 30px;
        line-height: 36px;
        font-weight: 600;
      }
    }
    .numberSource:active {
      background: #ffffff;
    }
    .numberSource.clear {
      h3 {
        font-weight: 500;
        line-height: 28px;
      }
    }
  }
`;
